import { registerComponent, asyncRequest } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "article-summary",
  class ArticleSummary extends WYATTElement {
    constructor() {
      super();

      this.endpoint = `${WYATT.routes.root}blogs/${this.dataset.handle}?view=summary`;

      this.getArticleSummary();
    }

    async getArticleSummary() {
      if (WYATT.searchspring.cached.articles[this.dataset.handle]) {
        this.replaceWith(
          WYATT.searchspring.cached.articles[this.dataset.handle],
        );
        return;
      }

      const response = await asyncRequest(this.endpoint);

      if (response) {
        this.handleSuccessfulUpdate(response);
      }
    }

    handleSuccessfulUpdate(html) {
      const articleSummary = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".article-summary");

      WYATT.searchspring.cached.articles[this.dataset.handle] = articleSummary;

      this.replaceWith(articleSummary);
    }
  },
);
